<template>
  <div class="app-container">
    <Header></Header>

    <div class="audio-test-container">
      <h3>音效测试</h3>

      <div class="control-group">
        <h4>背景音乐</h4>
        <button class="btn btn-blue" @click="startBackgroundMusic">播放背景音乐</button>
        <button class="btn btn-red" @click="stopMusic">停止背景音乐</button>
      </div>

      <div class="control-group">
        <h4>基础音效</h4>
        <button class="btn btn-green" @click="playSound('basic.correct')">正确音效</button>
        <button class="btn btn-red" @click="playSound('basic.wrong')">错误音效</button>
      </div>

      <div class="control-group">
        <h4>特殊音效</h4>
        <button class="btn btn-purple" @click="playSound('sfx.countdown')">倒计时音效</button>
        <button class="btn btn-gold" @click="playSound('sfx.win')">胜利音效</button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import AudioService from '@/services/AudioService'

export default {
  components: {
    Header
  },
  data() {
    return {
      audioService: AudioService
    }
  },
  mounted() {
    this.audioService.init();
  },
  methods: {
    playSound(soundName) {
      this.audioService.play(soundName)
        .then(() => console.log(`${soundName} 播放成功`))
        .catch(e => console.error(`${soundName} 播放失败:`, e));
    },
    startBackgroundMusic() {
      this.audioService.play('bgm.main', { loop: true })
        .then(() => console.log('背景音乐开始播放'))
        .catch(e => console.error('背景音乐播放失败:', e));
    },
    stopMusic() {
      this.audioService.stopBackground();
      console.log('背景音乐已停止');
    }
  }
}
</script>

<style scoped>
.audio-test-container {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
}

.control-group {
  margin: 20px 0;
  padding: 15px;
  background: #f8f8f8;
  border-radius: 8px;
}

.control-group h4 {
  margin-top: 0;
  color: #333;
}

.btn {
  margin: 5px;
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.btn-blue { background: #2196F3; }
.btn-red { background: #F44336; }
.btn-green { background: #4CAF50; }
.btn-purple { background: #9C27B0; }
.btn-gold { background: #FFD700; color: #333; }
</style>



// WEBPACK FOOTER //
// src/page/test.vue